module.exports = __webpack_public_path__ + "img/Announcement.1a4e53d0.svg";